import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../../api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hsn-sac',
  templateUrl: './hsn-sac.component.html',
  styleUrls: ['./hsn-sac.component.scss']
})
export class HSNSACComponent implements OnInit, AfterViewInit {

  HSNSACList: any = [];
  //hsnsacList:any=[];
  ERPConfigList: any = [];
  jarvisData: any = [];
  agencyData: any = [];

  isEditHSN: boolean = false;

  modalReference: any;
  closeResult: any;
  @ViewChild('mymodal') addModalRef!: TemplateRef<any>;

  HSNSAC = {
    h: '',
    per: '',
    c: '',
    hID: 0
  }

  constructor(private apiService: APIService, private modalService: NgbModal, public commonService: CommonService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    
    let HsnSacData = this.apiService.getCookie("ERP_Cfg");
    if (HsnSacData) {
      this.ERPConfigList = JSON.parse(HsnSacData);
    }
    this.HSNSACList = JSON.parse(this.ERPConfigList[0].HSNSAC);

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open(this.addModalRef, 0);
        }, 100);
      }
    });
  }

  //open and edit for HSN 
  open(content: any, id: number) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'AddHsnModel', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    if (id == 0) {
      this.isEditHSN = false;
      this.resetdata();
    }
    else if (id != 0) {
      var hsnData = this.HSNSACList.filter(function (element: any, index: any) {
        return (element.HID == id);
      });

      // this.HSNSAC = hsnData[0];

      this.HSNSAC.h = hsnData[0].H;
      this.HSNSAC.per = hsnData[0].Per;
      this.HSNSAC.c = hsnData[0].C;
      this.HSNSAC.hID = hsnData[0].HID;
      this.isEditHSN = true;
      // this.HSNSAC = hsnOld;

    }
  }


  private getDismissReason(reason: any): string {
    this.isEditHSN = false;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
    // this.isEditCategory = false;
  }

  public closeModal($event: any) {
    this.isEditHSN = false;
    this.resetdata();
    this.modalReference.close();
    if ($event) {
      //this.changingValue.next($event);
    }
  }

  //deletehsn() - delete hsnsac
  deletehsn(i: number) {
    if (confirm("Do you wish to delete this HSN/SAC?")) {
      this.HSNSACList.splice(i, 1);
      this.save()

    }

  }

  // save final data
  save() {
    var tempData = [{
      'ChangeType': 'HSNSAC',
      'GSTLdgrs': '',
      'Units': '',
      'Stores': '',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod': 1,
      'PrdRejnReasons': '',
      'HSNSAC': JSON.stringify(this.HSNSACList),
    }]
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
    }];
    this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  //success Entry
  successEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table1) {
          let coockieData = [];
          coockieData.push(ErpData.Table1[0]);
          let ErpAgn = JSON.stringify(coockieData);
          localStorage.setItem("ERP_Agn", ErpAgn)
        }
        if (ErpData.Table2) {
          let cookieData2 = [];
          cookieData2.push(ErpData.Table2[0]);
          let ErpCfgData = JSON.stringify(cookieData2);
          localStorage.setItem("ERP_Cfg", ErpCfgData)
        }
      }
      this.HSNSACList = [];
      let HsnSacData = this.apiService.getCookie("ERP_Cfg");
      if (HsnSacData) {
        this.ERPConfigList = JSON.parse(HsnSacData);
      }

      this.HSNSACList = JSON.parse(this.ERPConfigList[0].HSNSAC);

      this.resetdata();
    }
  }

  resetdata() {
    this.HSNSAC.h = '',
      this.HSNSAC.per = '',
      this.HSNSAC.c = '',
      this.HSNSAC.hID = 0
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    // else {
    //     alert(res.message);
    // }
  }

  //saveNewHsn() - add new categories
  saveNewHsn(hsn: any) {
    console.log(hsn)
    if (hsn.h == '') {
      this.apiService.successAlert("Please enter HSN/SAC name.")
      return;
    } else if (hsn.per == '') {
      this.apiService.successAlert("Please enter HSN/SAC Percentage.")
      return;
    } else {
      // let temp = {
      //   'HID': hsn.hID > 0 ? hsn.hID : this.HSNSACList[this.HSNSACList.length - 1].HID + 1,
      //   'H': hsn.h,
      //   'C': hsn.c,
      //   'Per': hsn.per
      // }
      let temp = {
        'HID': this.HSNSACList.length == 0 ? 1 : this.HSNSACList[this.HSNSACList.length - 1].HID + 1,
        'H': hsn.h,
        'C': hsn.c,
        'Per': hsn.per
      }

      var dupName = this.HSNSACList.filter((x: any) => x.H == hsn.h);

      if (dupName.length == 0) {
        if (hsn.hID == 0) {
          this.HSNSACList.push(temp);
        }
        for (let i = 0; i < this.HSNSACList.length; i++) {
          if (this.HSNSACList[i].HID == hsn.hID) {
            this.HSNSACList[i].H = hsn.h;
            this.HSNSACList[i].C = hsn.c;
            this.HSNSACList[i].Per = hsn.per;
            break
          }
        }

        this.save()
        this.modalReference.close();
      } else {
        this.apiService.successAlert("This HSC/SAC already exists.")
        this.resetdata();
        return;
      }
    }
  }



  //Add <--&--> Edit HSN-NO Open Model
  EditHsnModel(hsn: any) {
    var dupName = this.HSNSACList.filter((x: any) => x.H == hsn.h && x.HID != hsn.hID);

    if (dupName.length > 0) {
      this.apiService.successAlert("This HSC/SAC already exists.")
     return;
    }

    if (dupName.length == 0 ) {
      // var HSNdata = this.HSNSACList.filter(function (element: any, index: any) {
      //   return (element.HID == hsn.hID);
      // });


      for (let i = 0; i < this.HSNSACList.length; i++) {
        if (this.HSNSACList[i].HID == hsn.hID) {
          this.HSNSACList[i].H = hsn.h;
          this.HSNSACList[i].C = hsn.c;
          this.HSNSACList[i].Per = hsn.per;
          break;
        }
      }

      this.save()
      this.modalReference.close();
    } else {
      this.apiService.successAlert("This HSC/SAC already exists.")
      //this.resetdata();
      return;
    }

    // this.modalReference = this.modalService.open(content,{windowClass: "AddHsnModel", backdrop: 'static', keyboard: false });
    // this.modalReference.result.then((result: any) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason: any) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }



  SaveEditHSN() {

  }

  backBtn() {
    window.history.back();
  }

  changeColor(ind: any) {
    var clr = ""
    switch (ind) {

      case 0: {
        clr = 'orangeBadge'
        break;
      }
      case 1: {
        clr = 'yellowBadge'
        break;
      }
      case 2: {
        clr = 'greenBadge'
        break;
      }
      case 3: {
        clr = 'tealBadge'
        break;
      }
      case 4: {
        clr = 'blueBadge'
        break;
      }
      case 5: {
        clr = 'darkBlueBadge'
        break;
      }
      case 6: {
        clr = 'brownBadge'
        break;
      }

    }
    return clr;
  }

  //Type numberOnly Input text
 numberOnly(event: any): boolean {
  return this.commonService.numberOnly(event);
  } 

}
